/* @flow */

export default class DisableInvestmentProfileRequest {
  companyId: number;
  investmentProfileId: number;
}
